// extracted by mini-css-extract-plugin
module.exports = {"footer":"style__footer__ON3ZX","wrapper":"style__wrapper__VEjcx","links":"style__links__C45q4"};